import Inputmask from 'inputmask';

import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    Inputmask({
      mask: { 'mask': '(+7 ### ###-##-##)|(+375 ## ###-##-##)|(+996 ## ###-##-##)'},
      greedy: true,
      definitions: { '#': { validator: '[0-9]', cardinality: 1 } },
      skipOptionalPartCharacter: ' '
    }).mask(this.element)
  }
}
